import { ptBR } from "date-fns/locale";

/**
 * Locale do vue3-datepicker em português. O ptBR puro devolve o nome inteiro do dia
 * ("segunda-feira") no cabeçalho do calendário, que não cabe e embola as colunas;
 * aqui o cabeçalho usa abreviações e a semana começa na segunda.
 */
export const datepickerLocale = {
  ...ptBR,
  options: {
    ...ptBR.options,
    weekStartsOn: 1,
  },
  localize: {
    ...ptBR.localize,
    day: (n) => ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"][n],
  },
};
